/*
  Ordinalizes the given number, e.g. ordinalize(1) => "1st",
                                     ordinalize(2) => "2nd",
                                     ordinalize(3) => "3rd",
                                     ...

  The rules are as follows:

 - st is used with numbers ending in 1 (e.g. 1st, pronounced first)
 - nd is used with numbers ending in 2 (e.g. 92nd, pronounced ninety-second)
 - rd is used with numbers ending in 3 (e.g. 33rd, pronounced thirty-third)
    As an exception to the above rules, all the "teen" numbers ending with 11, 12 or 13 use -th
    (e.g. 11th, pronounced eleventh, 112th, pronounced one hundred [and] twelfth)

    th is used for all other numbers (e.g. 9th, pronounced ninth).

    Implementation taken from:
    https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
*/
export const ordinalize = (num) => {
  const j = num % 10;
  const k = num % 100;
  if (j === 1 && k !== 11) {
    return `${num}st`;
  }
  if (j === 2 && k !== 12) {
    return `${num}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${num}rd`;
  }
  return `${num}th`;
};

export const toRealNumber = (value, precision = 0) => (
  !Number.isNaN(parseFloat(value)) ? Number.parseFloat(value).toFixed(precision) : ''
);

export const formatCurrency = (value, precision = 2) => {
  let formattedCurrency = '$0.00';
  if (value) {
    // This will add $ when adding line items
    formattedCurrency = value[0] === '$' ? value : Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: precision }).format(value);
  }

  return formattedCurrency;
};

export const formatCurrencyPlain = (value, precision = 2) => {
  if (!value) return '';

  return Intl.NumberFormat('en-US', { minimumFractionDigits: precision }).format(String(value).replace(/,/, ''));
};
